/*
 * reviews-cards.js — star rating on product cards (collection / search / home).
 *
 * Self-contained, Brave-safe progressive enhancement:
 *   1. Finds every rating placeholder on the page: <span class="rv-card-rating" data-rv-card-id="<product.id>">
 *   2. Batches all product IDs into ONE request to the Worker /aggregates endpoint.
 *   3. Fills each placeholder with stars + score + count; products with no reviews
 *      stay hidden (never "0/10").
 * If the fetch is blocked (Brave shields) or fails, cards simply show no rating — the
 * page is never broken. Rating is an enhancement, not gated content.
 */
(function () {
  'use strict';

  var WORKER_BASE = 'https://innovazone-reviews.innovazone-cr.workers.dev';
  var MAX_PER_REQUEST = 100;

  function injectStyleOnce() {
    if (document.getElementById('rv-card-style')) return;
    var css =
      '.rv-card-rating[hidden]{display:none!important}' +
      '.rv-card-rating{display:inline-flex;align-items:center;gap:4px;margin:2px 0 0;line-height:1;font-size:12px}' +
      '.rv-card-rating__stars{display:inline-flex;gap:1px;font-size:12px}' +
      '.rv-card-rating__star--on{color:#FBBF24}.rv-card-rating__star--off{color:#D1D5DB}' +
      '.rv-card-rating__score{font-weight:800;color:#1B4F72}' +
      '.rv-card-rating__count{color:#6B7280}';
    var style = document.createElement('style');
    style.id = 'rv-card-style';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function starsHtml(avg) {
    var stars5 = avg / 2;
    var on = Math.round(stars5);
    var html = '';
    for (var i = 1; i <= 5; i++) {
      html += '<span class="rv-card-rating__star ' +
        (i <= on ? 'rv-card-rating__star--on' : 'rv-card-rating__star--off') + '">★</span>';
    }
    return html;
  }

  function fill(el, agg) {
    if (!agg || !agg.total_count) { el.hidden = true; return; }
    var score = Number(agg.avg_rating).toFixed(1);
    el.innerHTML =
      '<span class="rv-card-rating__stars" aria-hidden="true">' + starsHtml(agg.avg_rating) + '</span>' +
      '<span class="rv-card-rating__score">' + score + '</span>' +
      '<span class="rv-card-rating__count">(' + agg.total_count + ')</span>';
    el.setAttribute('aria-label', 'Calificación ' + score + ' de 10, ' + agg.total_count + ' reseñas');
    el.hidden = false;
  }

  function chunk(arr, size) {
    var out = [];
    for (var i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
    return out;
  }

  function init() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll('.rv-card-rating[data-rv-card-id]'));
    if (!nodes.length) return;

    injectStyleOnce();

    // Map id → [elements] (same product can appear twice on a page)
    var byId = {};
    var ids = [];
    nodes.forEach(function (el) {
      var id = el.getAttribute('data-rv-card-id');
      if (!id || !/^[0-9]+$/.test(id)) return;
      if (!byId[id]) { byId[id] = []; ids.push(id); }
      byId[id].push(el);
    });
    if (!ids.length) return;

    chunk(ids, MAX_PER_REQUEST).forEach(function (group) {
      var url = WORKER_BASE + '/aggregates?product_ids=' + encodeURIComponent(group.join(','));
      fetch(url)
        .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
        .then(function (data) {
          var aggs = (data && data.aggregates) || {};
          group.forEach(function (id) {
            (byId[id] || []).forEach(function (el) { fill(el, aggs[id]); });
          });
        })
        .catch(function (err) {
          // Brave-safe: leave placeholders hidden, never break the listing.
          console.warn('[rv-cards] aggregates fetch failed:', err);
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
